import { render, staticRenderFns } from "./UtenteList.vue?vue&type=template&id=1e195976&"
import script from "./UtenteList.vue?vue&type=script&lang=ts&"
export * from "./UtenteList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports